module.exports = __webpack_public_path__ + "img/ring_skip_skip_1_0@3x.2c60ad28.png";